import Component from '../abstracts/Component';
import { AllVisible } from '../utils/AllVisible';

export default class TooltipComponent extends Component {


  get SELECTORS() {
    return {
      container :'.js-tooltip-container',
      tooltip: '.js-tooltip',
      placeholderImg: '.js-placeholder-img'
    };
  }


  constructor() {
    super();
  }


  wcag(element) {
    element.addEventListener("keypress", function(e) {
      e.preventDefault();
      if (e.keyCode === 13) {
        element.click();
      }
    });
  }


  bindTooltips() {

    // DO NOT DELETE
    // let arr = document.querySelectorAll("tutti.i.tooltip");
    // arr.forEach( function() {
    //   // bind tooltip on 'this'
    //   // if not already bound
    // });

    this.$on('click.tooltip', ({event, payload}) => {
      event.preventDefault();
      event.stopPropagation();
      const data =  event.currentTarget.dataset;
      const created = document.querySelector(`#${data.target}`) ? true : false;
      const p = event.currentTarget.getBoundingClientRect();
      const pImg = event.currentTarget.parentElement.querySelector(this.SELECTORS.placeholderImg);
      const scrollTop = window.pageYOffset;
      const scrollLeft = window.pageXOffset;
      const xP = p.left + scrollLeft + 20 + 'px';
      const yP = p.top + scrollTop + 20 + 'px';

      this.destroyAllTooltips().then(res => {
        if (!created) {
          this.$emit(this.$customEvents.TOOLTIP_EVENTS.create, {pImg:pImg, data:data, xP:xP, yP:yP});
        }
      })
    }, 'body', this.SELECTORS.tooltip);

  }

  createTooltip(pImg, data, xP, yP) {

    return new Promise ((resolve, reject) => {
      try {

        let tooltip = document.createElement('div');
        let xOffset = 0;
        let yOffset = 0;

        if(pImg) {
          const imageEl = new Image(pImg.naturalWidth, pImg.naturalHeight);
          imageEl.src = pImg.src;
          imageEl.className = 'tooltip-image';
          tooltip.appendChild(imageEl);
        }

        if(data.text) {
          let textEl = document.createElement('span');
          textEl.innerHTML = data.text;
          textEl.className = 'tooltip-label';
          tooltip.appendChild(textEl);
        }

        tooltip.style.width = pImg ? pImg.naturalWidth + 'px' : 'auto';
        tooltip.style.height = pImg ? pImg.naturalHeight + 'px' : 'auto';



        if( tooltip.style.width == 'auto' && tooltip.style.height == 'auto' ) {
          xOffset = parseFloat(xP);
          yOffset = parseFloat(yP);
        } else {
          xOffset = parseFloat(xP) + parseFloat(tooltip.style.width);
          yOffset = parseFloat(yP) + parseFloat(tooltip.style.height);
        }


        tooltip.style.top = yP;
        tooltip.id = data.target;
        tooltip.className = 'tooltip-cvv';
        tooltip.style.position = 'absolute';
        tooltip.style.zIndex = '100';
        tooltip.style.width = '250px';


        if( AllVisible(tooltip, 548, 972) ) {
          console.log('[Tooltip], is all visible');
          tooltip.style.left = xP;
        } else {
          console.log('[Tooltip], is partially hidden');
          tooltip.style.left = 'auto';
          tooltip.style.right = 0;
        }

        document.body.appendChild(tooltip);

        resolve();
      }
      catch(e) {
        reject(e);
      }
    })
  }


  destroyAllTooltips() {
    return new Promise((resolve, reject) => {
      try {
      this.$off('click.tooltip');
      const targets = document.querySelectorAll('.tooltip-cvv');

      targets.forEach(target => {
        $(target).remove();
      });
      resolve()
      } catch (e) {
        reject(e)
      }
    });
  }


  bindEvents() {
    this.$on(this.$customEvents.TOOLTIP_EVENTS.create, ({payload}) => {

      this.createTooltip(payload.pImg, payload.data, payload.xP, payload.yP).then(res => {
        this.$on('click.tooltip', ({event}) => {
          event.stopPropagation();
          this.$emit(this.$customEvents.TOOLTIP_EVENTS.destroy);
        });
      });

    });

    this.$on(this.$customEvents.TOOLTIP_EVENTS.destroy, ({payload}) => {
      this.destroyAllTooltips();
    });

  }

  render() {

    // DO NOT DELETE
    // document.on("domchanged", this.bindEvents.bind(this) );
    this.bindEvents();
    this.bindTooltips();
    
  }
}
